var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgResponsibleGamingArrowSv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon responsible-gaming-arrow-icon",
    viewBox: "0 0 4 10",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.094 8.774a.453.453 0 00.078.631.44.44 0 00.623-.079l3.111-4.05a.453.453 0 000-.552L.796.674a.442.442 0 00-.624-.08.453.453 0 00-.078.632L2.993 5l-2.9 3.774z"
  })));
}

export default SvgResponsibleGamingArrowSv;